import env from "~/env";

/**
 * True if the current installation is the cloud hosted version at getoutline.com
 */
const isCloudHosted = [
  "https://wiki.dreamgallop.com",
  "https://wiki-admin.dreamgallop.com",
  "http://app.outline.dev",
  "http://app.outline.dev:3000",
].includes(env.URL);

export default isCloudHosted;
